export const DIMENSIONS = { width: 600, height: 300 }

export const HELP_ID = '7af3d62a-1d85-484d-b2f4-7d166ca45911'

export const DYNAMIC_EDIT_PAGE_PANEL_ACTIONS = {
  OPEN_ADD_DYNAMIC_PAGE_PANEL: 'OPEN_ADD_DYNAMIC_PAGE_PANEL',
  ADD_DYNAMIC_EDIT_PAGE: 'ADD_DYNAMIC_EDIT_PAGE',
}
